import styled from 'styled-components';
import { AlertCross } from 'assets/icons';
const Alert = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background: #fef1ef;
  border-radius: 5px;
  padding: 11px 7px;
  margin-bottom: 17px;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: var(--errorRed);
`;

export const AlertCrossStyled = styled(AlertCross)`
  margin-right: 7px;
`;

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  error?: string;
  className?: string;
}

const StaticTooltip = ({ error, className }: Props) => (
  <Alert className={className} data-testid="errorAlert">
    <AlertCrossStyled />
    {error}
  </Alert>
);

export default StaticTooltip;
